import { createSelector } from 'reselect';
import { name, initialState } from './slice';

export const packageLogisticOperatorDepartureSelector = (state) =>
  state[name] || initialState;

export const packageLogisticOperatorDepartureItemsSelector = (state) =>
  Object.values(state[name].items);

export const packageLogisticOperatorDepartureSearchSelector = (state) =>
  state[name].search;

export const packageLogisticOperatorDepartureTypeSelector = (state) =>
  state[name].departureType;

export const packageLogisticOperatorDepartureOriginSelector = (state) =>
  state[name].originID;

export const packageLogisticOperatorDepartureDestinySelector = (state) =>
  state[name].destinyID;

export const packageLogisticOperatorRemovePacketIDSelector = (state) =>
  state[name].removePacketID;

export const packageLogisticOperatorDepartureLoadedSelector = (state) =>
  state[name].loaded;

export const packageLogisticOperatorDeparturePageableSelector = (state) =>
  state[name].pageable;

const makePackageLogisticOperatorDepartureSelector = () =>
  createSelector(
    packageLogisticOperatorDepartureSelector,
    (substate) => substate,
  );

export const packageLogisticOperatorFilteredItemsSelector = createSelector(
  packageLogisticOperatorDepartureItemsSelector,
  packageLogisticOperatorDeparturePageableSelector,
  packageLogisticOperatorDepartureSearchSelector,
  packageLogisticOperatorDepartureDestinySelector,
  packageLogisticOperatorDepartureOriginSelector,
  (items, { pageSize, pageNumber }, search, destiny, origin) => {
    if (!destiny || !origin) {
      return [];
    }
    let resultItems = items;
    if (search) {
      resultItems = resultItems.filter((item) => {
        const searchIgnoreCase = search.toUpperCase();
        const externalCodeIgnoreCase = item.externalCode.toUpperCase();
        return (
          externalCodeIgnoreCase &&
          externalCodeIgnoreCase.includes(searchIgnoreCase)
        );
      });
    }
    if (destiny) {
      resultItems = resultItems.filter((item) => item.destinyID === destiny);
    }
    if (origin) {
      resultItems = resultItems.filter((item) => item.originID === origin);
    }
    const start = pageNumber * pageSize;
    const end = pageNumber * pageSize + pageSize;
    const totalElements = resultItems.length;
    resultItems = resultItems.slice(start, end);
    return {
      pageable: {
        pageNumber,
        pageSize,
        totalElements,
      },
      items: resultItems,
    };
  },
);

export default makePackageLogisticOperatorDepartureSelector;
